export default __webpack_public_path__ + "097adea34c736cad389b4252d73fc4c6.png";